import { Injectable } from '@angular/core';
import { DataTransformAbstractPost } from 'app/modules/global/classes/data.transform.abstract.down';
import { CustomerInterface } from 'app/models/customer.model';
import { FluidDatePipe } from 'app/modules/global/pipes/fluidDate.pipe';

@Injectable({
  providedIn: 'root',
})
export class CustomerDataTransformPost extends DataTransformAbstractPost {
  constructor(protected _fluidDatePipe: FluidDatePipe) {
    super();
  }

  transform(customer: CustomerInterface): CustomerInterface {
    if (Array.isArray(customer.systems)) {
      customer.systems = <any>customer.systems.map((v) => v.id);
    }
    return customer;
  }
}
